import React from 'react'
import type { ToastId, UseToastOptions } from '@chakra-ui/react'
import { useToast as useChakraToast } from '@chakra-ui/react'
/**
 *
 * IMPORTANT
 *
 * @see Toast.tsx in components
 *
 * DO NOT REFACTOR TO UI-KIT
 *
 */
import Toast from '../components/Toast'

const useToast: typeof useChakraToast = (defaultOptions?: UseToastOptions) => {
  const toast = useChakraToast(defaultOptions)

  function renderToast(options?: UseToastOptions): string | number | undefined {
    return toast({
      ...options,
      render: props => (
        <Toast
          props={props}
          options={{
            duration: 5000,
            position: 'bottom',
            variant: 'outline',
            ...options,
          }}
        />
      ),
    })
  }

  renderToast.close = toast.close
  renderToast.closeAll = toast.closeAll
  renderToast.isActive = toast.isActive
  renderToast.update = (
    id: ToastId,
    options: Pick<
      UseToastOptions,
      | 'position'
      | 'onCloseComplete'
      | 'duration'
      | 'title'
      | 'status'
      | 'render'
      | 'description'
      | 'isClosable'
      | 'variant'
    >,
  ) => {
    toast.update(id, options)
  }

  return renderToast
}

export default useToast
